import * as React from 'react';
import { useController, useForm } from "react-hook-form";
import {useState} from "react";

import {HuePicker} from "react-color";
import {Button, Grid} from "@mui/material";
import cloneDeep from 'lodash.clonedeep';

import Input from "@/pages/form/TextField";
import RadioGroup from "@/pages/form/RadioGroup";

const ColorPicker = ({ name, control, defaultValue = '' }) => {
    const {
        field: { onChange, onBlur, value, ref },
    } = useController({
        name,
        control,
        defaultValue,
    });

    return (
        <HuePicker color={value} onChange={(newColor) => onChange(newColor.hex)} width={"auto"}/>
    )
}

export const Form = ({ config, onSubmit }) => {
    const { handleSubmit, register, control, getValues, setValue } = useForm({
        defaultValues: {
            ...config.form.reduce((acc, { name, value }) => {
                acc[name] = value;

                return acc
            }, {})
        },
        mode: "onSubmit"
    });

    const prepareSubmit = (data) => {
        const newConfig = cloneDeep(config);

        newConfig.form.forEach((field) => {
            field.value = data[field.name];
        });

        onSubmit?.(newConfig)
    }

    const renderField = (field) => {
        if (field.type === 'radio') {
            return (
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <RadioGroup control={control}/>
                </Grid>
            )
        }

        if (field.type === 'color') {
            return (
                <Grid item xs={12} >
                    <ColorPicker name={'color'} control={control} defaultValue={getValues('color')}/>
                </Grid>
            )
        }

        return (
            <Grid item xs={12} >
                <Input register={register} name={field.name} label={field.label}/>
            </Grid>
        )
    }

    return (
        <form onSubmit={handleSubmit(prepareSubmit)} noValidate>
            <Grid container spacing={2}>
                {
                    config.form.map((field) => renderField(field))
                }

                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color="secondary">Submit</Button>
                </Grid>
            </Grid>
        </form>
    );
}